import { render, staticRenderFns } from "./BlockCatalog.vue?vue&type=template&id=212ef62d"
import script from "./BlockCatalog.vue?vue&type=script&lang=js"
export * from "./BlockCatalog.vue?vue&type=script&lang=js"
import style0 from "./BlockCatalog.vue?vue&type=style&index=0&id=212ef62d&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports